(function () {
  'use strict';

  angular.module('ringbaPortal').component('routeFilterForm', {
    bindings: {
      filterContainerObj: '<',
      availableTags: '<',
      showFullWidthOptions: '<',
      isReadOnly: '<',
      enableScrolling: '<',
      setFilterContainerObj: '&',
      onBulkTagUpload: '&',
      formNameForUserSettings: '@',
      isCriteriaInverted: '<'
    },
    controller: RouterFilterFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/route-filter-form/route-filter-form.view.html'
  });

  function RouterFilterFormController(
    _,
    $anchorScroll,
    $filter,
    $timeout,
    $translate,
    accountsService,
    bulkTagsService,
    comparisonTypeService,
    geoStatesService,
    isMobileDevice,
    mediaQueryService,
    tagService,
    toaster
  ) {
    'ngInject';

    const vm = this;
    let uploadedBulkTagsNames = {};
    const orFilter = tagService.getDefaultTag(),
      andFilter = {
        tagCriteria: [orFilter]
      },
      defaultFilterCriteria = [
        {
          tagCriteria: [
            {
              'tagId': '',
              'tagIds': [''],
              'comparisonType': comparisonTypeService.defaultComparisonType.key,
              'comparisonTypeTemp': comparisonTypeService.defaultComparisonType,
              'value': ''
            }
          ]
        }
      ];

    vm.comparisonTypes = comparisonTypeService.comparisonTypes;
    vm.numberRegex = /^\d+$/;
    vm.uploadedBulkTags = [];
    vm.isStreamlinedZipcodeActive = {};
    vm.selectedBulkTagUpload = {};

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.addANDRule = addANDRule;
    vm.addORRule = addORRule;
    vm.removeRule = removeRule;
    vm.onComparisonTypeChange = onComparisonTypeChange;
    vm.groupByTags = groupByTags;
    vm.enableEditView = enableEditView;
    vm.handleTagIdChange = handleTagIdChange;
    vm.handleTagChange = handleTagChange;
    vm.isArray = angular.isArray;
    vm.getGeoValue = tagService.getGeoValue;
    vm.isGeoTag = tagService.isGeoTag;
    vm.isStateGeoTag = tagService.isStateGeoTag;
    vm.isProvinceGeoTag = tagService.isProvinceGeoTag;
    vm.isOldProvinceTag = tagService.isOldProvinceTag;
    vm.doesHaveMultipleValues = tagService.doesHaveMultipleValues;
    vm.allowBulkTagsUpload = tagService.allowBulkTagsUpload;
    vm.getStateValueProperty = tagService.getStateValueProperty;
    vm.getProvinceValueProperty = tagService.getProvinceValueProperty;
    vm.getComparisonFilters = getComparisonFilters;
    vm.onNewBulkTagAdd = onNewBulkTagAdd;

    // Duplicate file warning
    vm.showDuplicateWarning = {};
    vm.duplicateFileName = {};
    // Duplicate file warning methods
    vm.setDuplicateWarning = setDuplicateWarning;
    vm.clearDuplicateWarning = clearDuplicateWarning;

    function onInit() {
      vm.USStatesList = geoStatesService.getUSStates();
      vm.canadianProvincesList = geoStatesService.getCanadianProvinces();
      vm.isMobileView = isMobileDevice && mediaQueryService.evaluateMediaQuery('xs');
      _getBulkTags();
    }

    function onChanges(changesObj) {
      if (changesObj.filterContainerObj
        &&
        (changesObj.filterContainerObj.isFirstChange()
          ||
          !_checkIfPreviousCriteriaValueIsEqual(vm.filterContainerObj, changesObj.filterContainerObj.previousValue)
        )
      ) {
        if (!vm.filterContainerObj) {
          vm.filterContainerObj = {};
        }

        const newCriteria = !(vm.filterContainerObj.criteria && vm.filterContainerObj.criteria.length);
        vm.filterContainerObj.criteria = newCriteria ? angular.copy(defaultFilterCriteria) : vm.filterContainerObj.criteria;
        vm.filterCriteriaCopy = angular.copy(vm.filterContainerObj.criteria);
        tagService.groupGeoTags(vm.filterCriteriaCopy);
        tagService.normalizeBulkTagForUI(vm.filterCriteriaCopy);
        vm.filterCriteriaCopy = comparisonTypeService.convertComparisonTypes(vm.filterCriteriaCopy);
        _setBulkTagName(vm.filterCriteriaCopy);
        _normalizeTagIds(vm.filterCriteriaCopy);
        _resetSummaryView(vm.filterCriteriaCopy, newCriteria);
      }
    }

    function removeRule(andIndex, orIndex) {
      vm.filterCriteriaCopy[andIndex].tagCriteria.splice(orIndex, 1);
      if (vm.filterCriteriaCopy[andIndex].tagCriteria.length === 0) {
        vm.filterCriteriaCopy.splice(andIndex, 1);
      }
      _setFilterCriteria();
    }

    function _syncSelectedBulkWithFilterCriteria() {
      _resetSelectedBulkTag();
      for (let andIndex = 0; andIndex < vm.filterCriteriaCopy.length; andIndex++) {
        for (let orIndex = 0; orIndex < vm.filterCriteriaCopy[andIndex].tagCriteria.length; orIndex++) {
          _propagateSelectedBulkTag(andIndex, orIndex, vm.filterCriteriaCopy[andIndex].tagCriteria[orIndex].tagId || vm.filterCriteriaCopy[andIndex].tagCriteria[orIndex].Id);
        }
      }
    }

    function _resetSelectedBulkTag() {
      vm.selectedBulkTagUpload = {};
    }

    function onComparisonTypeChange(comparisonType, orIndex, andIndex, criteria) {
      if (tagService.isOldProvinceTag(criteria)) {
        criteria.value = '';
        criteria.valueList = undefined;
      }
      if (comparisonTypeService.isBulkTagComparison(comparisonType.value) && _bulkTagExists(vm.filterCriteriaCopy[andIndex])) {
        toaster.pop('error', $translate.instant('BULK_RESTRICT_AND_MESSAGE'));
        vm.filterCriteriaCopy[andIndex].tagCriteria[orIndex].comparisonTypeTemp = criteria.oldComparisonTypeValue || comparisonTypeService.getDefaultBulkTagComparison();
        return;
      }

      criteria.comparisonTypeTemp = comparisonType;
      criteria.oldComparisonTypeValue = comparisonType;
      const filter = vm.filterCriteriaCopy[andIndex].tagCriteria[orIndex];
      if (comparisonType.key === 'GREATER_THAN' || comparisonType.key === 'LESS_THAN') {
        filter.isNumber = true;
      } else if (filter.isNumber) {
        filter.isNumber = false;
      }
      filter.isNegativeMatch = comparisonType.isNegativeMatch;
      filter.comparisonType = comparisonType.key;

      handleTagChange(vm.filterCriteriaCopy[andIndex], andIndex, orIndex);
    }

    function groupByTags(item) {
      return $filter('camelCaseFormat')(item.tagSource);
    }

    function enableEditView(andIndex, orIndex) {
      if (!vm.isReadOnly && vm.showFullWidthOptions) {
        vm.showFullWidthOptions.showSummaryView = false;
        vm.showFullWidthOptions.showCriteriaSummary[andIndex][orIndex] = false;
      }
    }

    function handleTagIdChange(criteria, newTagId, oldTagId, andIndex, orIndex, newTagIds, oldTagIds) {
      const isNewTagGeo = tagService.isGeoTag(newTagId, newTagIds);
      const isNewTagBulk = tagService.allowBulkTagsUpload(newTagId, newTagIds);

      oldTagIds = criteria.oldTagIds || oldTagIds;
      oldTagId = criteria.oldTagId || oldTagId;

      if (tagService.isGeoTag(newTagId, newTagIds)) {
        // Reset value if geo tag because the valueProperty is different
        criteria.value = '';
        criteria.valueList = undefined;
      } else if (isNewTagGeo) {
        // Reset criteria if new tag is a geo tag
        _resetCriteria(criteria, andIndex, orIndex);
      }

      if (tagService.allowBulkTagsUpload(newTagId, newTagIds)) {
        // Reset criteria if new tag is a bulk tag
        _resetCriteria(criteria, andIndex, orIndex);
      } else {
        delete criteria.isBulkTag;
      }

      if (tagService.allowBulkTagsUpload(oldTagId, oldTagIds) && !isNewTagBulk && !isNewTagGeo) {
        // Reset criteria if old tag is a bulk tag
        _resetCriteria(criteria, andIndex, orIndex);
      }

      if (newTagIds) {
        criteria.oldTagIds = newTagIds;
      } else {
        criteria.oldTagId = newTagId;
      }

      handleTagChange(vm.filterCriteriaCopy[andIndex], andIndex);
    }

    function handleTagChange(andObj, andIndex, orIndex, bulkTagUploadId) {
      vm.filterCriteriaCopy[andIndex] = andObj;
      vm.filterContainerObj.criteria[andIndex] = tagService.normalizeGeoTagsInAndObj(andObj, andIndex);
      vm.setFilterContainerObj({ filterContainerObj: vm.filterContainerObj });
      _propagateSelectedBulkTag(andIndex, orIndex, bulkTagUploadId);
    }

    function onNewBulkTagAdd(bulkTagUpload, andIndex, orIndex) {
      uploadedBulkTagsNames[bulkTagUpload.id] = bulkTagUpload.name;
      _setBulkTagName(vm.filterCriteriaCopy);
      vm.onBulkTagUpload();
      _propagateSelectedBulkTag(andIndex, orIndex, bulkTagUpload.id);
    }

    function _propagateSelectedBulkTag(andIndex, orIndex, bulkTagUploadId) {
      if (typeof (andIndex) != 'undefined' && typeof (orIndex) != 'undefined') {
        vm.selectedBulkTagUpload[andIndex + ':' + orIndex] = bulkTagUploadId;
      }
    }

    function _normalizeTagIds(filters) {
      filters.forEach(function (criteria, andIndex) {
        criteria.tagCriteria.forEach(function (tag, orIndex) {
          _propagateSelectedBulkTag(andIndex, orIndex, tag.Id);

          if (vm.showFullWidthOptions && !vm.isMobileView) {
            if ((!tag.tagIds || tag.tagIds.length == 0) && tag.tagId) {
              tag.tagIds = [
                tag.tagId
              ];
              tag.tagId = null;
            }
          }
        });
      });
    }

    function _getBulkTags() {
      bulkTagsService.getBulkTags(accountsService.currentAccountId).then(function (response) {
        vm.uploadedBulkTags = response.data.bulkTagUploads;
        uploadedBulkTagsNames = _.mapValues(_.keyBy(response.data.bulkTagUploads, 'id'), 'name');
        _setBulkTagName(vm.filterCriteriaCopy);
      });
    }

    function _setBulkTagName(filters) {
      if (filters && !_.isEmpty(uploadedBulkTagsNames)) {
        _.forEach(filters, function (andObj) {
          const bulkTag = _.find(andObj.tagCriteria, { isBulkTag: true, hasMultipleValues: true });
          if (bulkTag) {
            bulkTag.value = uploadedBulkTagsNames[bulkTag.Id];
          }
        });
      }
    }

    function getComparisonFilters(criteria) {
      return {
        forGeoTags: vm.isGeoTag(criteria.tagId, criteria.tagIds),
        forBulkTags: vm.allowBulkTagsUpload(criteria.tagId, criteria.tagIds),
        forMultipleValues: vm.doesHaveMultipleValues(criteria.tagIds)
      };
    }

    function _setFilterCriteria() {
      vm.filterContainerObj.criteria = tagService.normalizeGeoAndBulkTagsInCriterias(vm.filterCriteriaCopy);
      vm.setFilterContainerObj({ filterContainerObj: vm.filterContainerObj });
      _syncSelectedBulkWithFilterCriteria();
    }

    function _scrollTo(newElementId) {
      $timeout(function () {
        $anchorScroll(newElementId);
      });
    }

    function _resetCriteria(criteria, andIndex, orIndex) {
      if (!vm.isStreamlinedZipcodeActive[andIndex + ':' + orIndex]) {
        criteria.comparisonTypeTemp = vm.isGeoTag(criteria.tagId, criteria.tagIds)
          ? comparisonTypeService.getGeoTagComparison()
          : comparisonTypeService.getDefaultBulkTagComparison();
        criteria.isNumber = false;
        criteria.comparisonType = criteria.comparisonTypeTemp.key;
        criteria.isNegativeMatch = criteria.comparisonTypeTemp.isNegativeMatch;
        criteria.value = undefined;
      }
    }

    function _bulkTagExists(andObj) {
      return _.filter(andObj.tagCriteria, { isBulkTag: true, hasMultipleValues: true }).length > 1;
    }

    function _checkIfPreviousCriteriaValueIsEqual(previousContainerObj, currentFilterContainerObj) {
      return _.isEqual(currentFilterContainerObj && currentFilterContainerObj.criteria, previousContainerObj && previousContainerObj.criteria);
    }

    function _resetSummaryView(filters, newCriteria) {
      if (!vm.showFullWidthOptions) {
        return;
      }

      if (newCriteria) {
        vm.showFullWidthOptions.showCriteriaSummary = [[false]];
      } else {
        filters.forEach(function (criteria, andIndex) {
          if (typeof vm.showFullWidthOptions.showCriteriaSummary === 'undefined') {
            vm.showFullWidthOptions.showCriteriaSummary = [];
          }
          vm.showFullWidthOptions.showCriteriaSummary[andIndex] = vm.showFullWidthOptions.showSummaryView[andIndex] || [];

          criteria.tagCriteria.forEach(function (tag, orIndex) {
            vm.showFullWidthOptions.showCriteriaSummary[andIndex][orIndex] = true;
          });
        });
      }
    }

    // Shows duplicate file warning for specific filter
    function setDuplicateWarning(andIndex, orIndex, fileName) {
      const key = andIndex + ':' + orIndex;
      vm.showDuplicateWarning[key] = true;
      vm.duplicateFileName[key] = fileName;
    }

    // Hides duplicate file warning for specific filter
    function clearDuplicateWarning(andIndex, orIndex) {
      const key = andIndex + ':' + orIndex;
      vm.showDuplicateWarning[key] = false;
    }

    // Clears all duplicate file warnings
    function _clearAllDuplicateWarnings() {
      vm.showDuplicateWarning = {};
      vm.duplicateFileName = {};
    }
    function addANDRule($index) {
      _clearAllDuplicateWarnings(); // Clear warnings on new rule

      if (vm.showFullWidthOptions) {
        vm.showFullWidthOptions.showCriteriaSummary[$index + 1] = [false];
      }

      const newAndCondition = angular.copy(andFilter),
        newAndElementId = 'filter-item-and-' + ($index + 1);
      vm.filterCriteriaCopy.splice($index + 1, 0, newAndCondition);
      if (vm.enableScrolling) {
        _scrollTo(newAndElementId);
      }
      _setFilterCriteria();
    }

    function addORRule($index) {
      _clearAllDuplicateWarnings(); // Clear warnings on new rule

      if (vm.filterCriteriaCopy.length === 0) {
        vm.filterCriteriaCopy = angular.copy(defaultFilterCriteria);
        if (vm.showFullWidthOptions) {
          vm.showFullWidthOptions.showCriteriaSummary = [[false]];
        }

      } else {
        const newOrElementId = 'filter-item-or-' + $index + '-' + vm.filterCriteriaCopy[$index].tagCriteria.length;
        vm.filterCriteriaCopy[$index].tagCriteria.push(angular.copy(orFilter));
        if (vm.showFullWidthOptions) {
          vm.showFullWidthOptions.showCriteriaSummary[$index].push(false);
        }
        if (vm.enableScrolling) {
          _scrollTo(newOrElementId);
        }
      }
      _setFilterCriteria();
    }

  }
})();
